module.exports = __webpack_public_path__ + "img/IMG_1899_L_Black.5cc3ddbc.jpg";